import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const SectionTitle = ({ title, subtitle, actions }) => (
  <Stack
    direction={{ xs: 'column', md: 'row' }}
    spacing={1.5}
    alignItems={{ xs: 'flex-start', md: 'center' }}
    justifyContent="space-between"
    sx={{ mb: 2 }}
  >
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a', mb: 0.5 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Box>
    {actions && (
      <Stack direction="row" spacing={1} flexWrap="wrap">
        {actions}
      </Stack>
    )}
  </Stack>
);

export default SectionTitle;
